import gapImg from "../assets/img/8885624.jpg";
import afImg from "../assets/img/carFin.jpg";
import savingPortfolioImg from "../assets/img/saveWithHand.jpg";
let Constants = {
    ONBOARD: {
        INITIATE: "/v1/onboard",
        CONFIRM_OTP: {
            EMAIL_ADDRESS: "/v1/auth/onboard/confirmOtp/email",
            MOBILE_NUMBER: "/v1/auth/onboard/confirmOtp/mobileNumber"
        }
    },
    LOGIN: {
        INITIATE: "/v1/login",
        CONFIRM_OTP: {
            EMAIL_ADDRESS: "/v1/auth/login/confirmOtp/email",
            MOBILE_NUMBER: "/v1/auth/login/confirmOtp/mobileNumber"
        }
    },
    USER: {
        PROFILE: "/v1/user/profile"
    },
    SAVINGS: {
        ONE: "/v1/savings/one",
        ALL: "/v1/savings/all",
        NEW: "/v1/savings/save/new",
        PLANS_LENGTH: [
            {
                value: "3",
                text: "3 months (3% interest)"
            },
            {
                value: "6",
                text: "6 months (6.5% interest)"
            },
            {
                value: "9",
                text: "9 months (11% interest)"
            },
            {
                value: "12",
                text: "12 months (15% interest)"
            }
        ],
        PLANS_INTERVAL: [
            {
                value: "daily",
                text: "Daily"
            },
            {
                value: "weekly",
                text: "Weekly"
            },
            {
                value: "monthly",
                text: "Monthly"
            }

        ]
    },
    INVESTMENT: {
        ONE: "/v1/investments/one",
        NEW: "/v1/investments/create",
        TRANSFER: "/v1/investments/transfer",
        UPDATE: "/v1/investments/update",
    },
    TRANSACTIONS: {
        FUND: "/v1/transactions/fund",
        WITHDRAW: "/v1/transactions/withdraw",
    },
    ACCOUNTS: {
        UPDATE: "/v1/account/edit",
        BANK_UPDATE_DETAILS: "/v1/account/updateDetails",
        BANK_CREATE_DETAILS: "/v1/account/createDetails"
    },
    INVESTOR_TYPES: [
        {
            id: "1",
            name: "Beginner",
            icon: 1,
        },
        {
            id: "2",
            name: "Intermediate",
            icon: 2
        },
        {
            id: "3",
            name: "Experienced",
            icon: 3
        }
    ],
    nairaString: "₦",
    PORTFOLIOS: [
        {
            id: 1,
            db_id: 4,
            interestRate: "15",
            name: "Savings Portfolio",
            riskLevel: "low",
            pricePerUnit: 1000,
            portfolioSize: "100m",
            trustee: "Allianz",
            show: true,
            img: savingPortfolioImg,
            to: "/dashboard/portfolio/savings/summary",
            interestRates: [
                {
                    value: 3,
                    text: "3 months (3% interest)",
                    interest: 3
                },
                {
                    value: 6,
                    text: "6 months (6% interest)",
                    interest: 6
                },
                {
                    value: 9,
                    text: "9 months (11% interest)",
                    interest: 11
                },
                {
                    value: 12,
                    text: "12 months (15% interest)",
                    interest: 15
                }
            ],
        },
       
        {
            id: 2,
            db_id: 2,
            interestRate: "20",
            name: "Asset Finance Portfolio",
            riskLevel: "low",
            pricePerUnit: 50000,
            portfolioSize: "140m",
            trustee: "Allianz",
            show: true,
            img: afImg,
            to: "/dashboard/portfolio/asset-finance/summary",
            interestRates: [
                {
                    value: 3,
                    text: "3 months (3.5% interest)",
                    interest: 3.5
                },
                {
                    value: 6,
                    text: "6 months (8% interest)",
                    interest: 8,
                },
                {
                    value: 9,
                    text: "9 months (14% interest)",
                    interest: 14
                },
                {
                    value: 12,
                    text: "12 months (20% interest)",
                    interest: 20
                }
            ],
        },

        {
            id: 3,
            interestRate: "21",
            db_id: 5,
            name: "Green Finance Portfolio",
            riskLevel: "low",
            pricePerUnit: 100000,
            portfolioSize: "140m",
            trustee: "Allianz",
            show: false,
            img: gapImg,
            to: "/dashboard/portfolio/green-asset-finance/summary",
            interestRates: [
                {
                    value: 12,
                    text: "12 months (21% interest)",
                    interest: 21
                },
                {
                    value: 15,
                    text: "15 months (24% interest)",
                    interest: 24
                },
                {
                    value: 18,
                    text: "18 months (31% interest)",
                    interest: 31
                },
                {
                    value: 24,
                    text: "24 months (42% interest)",
                    interest: 42
                }
            ],
        },
        {
            id: 4,
            db_id: 1,
            interestRate: "30",
            name: "Working Capital Portfolio",
            riskLevel: "low",
            pricePerUnit: 50000,
            portfolioSize: "100m",
            trustee: "Allianz",
            show: false,
            img: savingPortfolioImg,
            to: "/dashboard/portfolio/savings/summary",
            interestRates: [
                {
                    value: 3,
                    text: "3 months (3% interest)",
                    interest: 3
                },
                {
                    value: 6,
                    text: "6 months (6% interest)",
                    interest: 6
                },
                {
                    value: 9,
                    text: "9 months (11% interest)",
                    interest: 11
                },
                {
                    value: 12,
                    text: "12 months (15% interest)",
                    interest: 15
                }
            ],
        },
        {
            id: 5,
            db_id: 3,
            interestRate: "31",
            name: "Women Traders Portfolio",
            riskLevel: "low",
            pricePerUnit: 50000,
            portfolioSize: "100m",
            trustee: "Allianz",
            show: false,
            img: savingPortfolioImg,
            to: "/dashboard/portfolio/savings/summary",
            interestRates: [
                {
                    value: "3",
                    text: "3 months (3% interest)",
                    interest: 3
                },
                {
                    value: "6",
                    text: "6 months (6% interest)",
                    interest: 6
                },
                {
                    value: "9",
                    text: "9 months (11% interest)",
                    interest: 11
                },
                {
                    value: "12",
                    text: "12 months (15% interest)",
                    interest: 15
                }
            ],
        },
        {
            id: 6,
            db_id: 6,
            interestRate: "20",
            name: "Large Asset Finance Portfolio",
            riskLevel: "low",
            pricePerUnit: 500000,
            portfolioSize: "140m",
            trustee: "ARM Trusteeship",
            show: false,
            img: afImg,
            to: "/dashboard/portfolio/asset-finance/summary",
            interestRates: [
                {
                    value: 3,
                    text: "3 months (3.5% interest)",
                    interest: 3.5
                },
                {
                    value: 6,
                    text: "6 months (8% interest)",
                    interest: 8,
                },
                {
                    value: 9,
                    text: "9 months (14% interest)",
                    interest: 14
                },
                {
                    value: 12,
                    text: "12 months (20% interest)",
                    interest: 20
                }
            ],
        },

    ],
    LANDING_PAGE: [
        {
            heroText: "Small steps, Big change.",
            subText: `So much of our impact on the Earth is determined by how we spend and make our money. For example, when we purchase a generator set from an electronic retail brand, our money supports the manufacturing of plastic-based metals, the use of fossil fuel energy, excess air waste, and in most cases, unfair labor practices.
            You can reverse this when you put your money into sustainable practices that supports organic food production, renewable energy, zero-plastic manufacturing, and fair labor practices. These are business practices that leave the Earth better than we found it.`,
        },
        {
            heroText: "Contribute",
            subText: `Put your money where your values are. Make a personal impact on the planet by
            saving into green portfolios for competitive returns and sustainable wealth creation.`
        },

        {
            heroText: "Split",
            subText: `Break payments into smaller bits at lower rates when you purchase
            Solar energy assets or energy saving appliances from our partners.`
        },

        {
            heroText: "Rewards",
            subText: `Earn green points when you invite your network, friends and family
            to save on Rouzo and join the efforts of building a greener planet.`
        },

        {
            heroText: "",
            subText: ""
        }
    ]

}

export default Constants;